const ENPrioritizationMatrix = {
	"Ações Novas": "New Actions",
	"Erro ao atualizar ação": "Error updating action",
	"Não urgente": "Not urgent",
	"Não importante": "Not important",
	"Matriz de priorização": "Prioritization matrix",
	"Matriz de Priorização": "Prioritization Matrix",
	"Faça agora": "Do it now",
	"Planeje quando fazer": "Schedule it",
	"Delegue": "Delegate",
	"Faça isso depois": "Do it later"
};

export default ENPrioritizationMatrix;

